import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import robotWave from '../../assets/icon/robot_wave.png'
import robotChat from '../../assets/icon/robot_chat.png'
import robotHeadset from '../../assets/icon/robot_headset.png'

const POSES = [robotWave, robotChat, robotWave, robotChat]

export default function RobotMascot({ size = 108, isOpen = false }) {
  const [poseIdx, setPoseIdx] = useState(0)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (isOpen) return
    const interval = setInterval(() => {
      setVisible(false)
      setTimeout(() => {
        setPoseIdx((i) => (i + 1) % POSES.length)
        setVisible(true)
      }, 300)
    }, 3500)
    return () => clearInterval(interval)
  }, [isOpen])

  const src = isOpen ? robotHeadset : POSES[poseIdx]

  return (
    <>
      <style>{`
        @keyframes rmBounce {
          0%,  100% { transform: translateY(0); }
          8%         { transform: translateY(-12px); }
          16%        { transform: translateY(0); }
          22%        { transform: translateY(-6px); }
          28%        { transform: translateY(0); }
        }
        .rm-bounce { animation: rmBounce 5s ease-in-out infinite; }
        .rm-fade   { transition: opacity 0.3s ease; }
      `}</style>
      <div
        style={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          className="rm-fade rm-bounce"
          src={src}
          alt="Aitime robot"
          style={{
            width: size,
            height: size,
            objectFit: 'contain',
            opacity: visible ? 1 : 0,
            transform: visible ? 'scale(1)' : 'scale(0.85)',
          }}
        />
      </div>
    </>
  )
}

RobotMascot.propTypes = {
  size: PropTypes.number,
  isOpen: PropTypes.bool,
}
